import React from 'react';
import SEO from '../components/SEO';
import { Link } from 'react-router-dom';

const Home = () => {
  const services = [
    { title: 'Restaurants', icon: '🍽️', description: 'Nettoyage professionnel des cuisines et espaces de restauration' },
    { title: 'Hôtels', icon: '🏨', description: 'Entretien complet des établissements hôteliers' },
    { title: 'Bureaux', icon: '🏢', description: 'Nettoyage quotidien des espaces de travail' },
    { title: 'Commerces', icon: '🏪', description: 'Solutions adaptées aux locaux commerciaux' },
    { title: 'Post-Chantier', icon: '🏗️', description: 'Nettoyage professionnel après travaux' },
    { title: 'Dépôts', icon: '🏭', description: 'Entretien des zones de stockage et entrepôts' }
  ];

  return (
    <div className="min-h-screen">
      <SEO 
        title="E-omi Services – Nettoyage Professionnel en Île-de-France | Devis Gratuit"
        description="Services de nettoyage professionnels pour restaurants, hôtels, bureaux et commerces en Île-de-France. Interventions rapides et devis gratuit."
        path="/"
      />
      {/* Hero Section - Ajustement de la hauteur */}
      <div className="relative min-h-[100vh] bg-gradient-to-r from-blue-600 to-blue-800">
        <div className="absolute inset-0 bg-black opacity-50"></div>
        <div className="relative max-w-7xl mx-auto px-4 py-16 sm:px-6 lg:px-8 min-h-[100vh] flex items-center">
          <div className="text-center text-white w-full">
            <h1 className="text-3xl sm:text-4xl md:text-6xl font-bold font-mulish mb-6 px-4">
              Services de Nettoyage Professionnels
            </h1>
            <p className="text-lg sm:text-xl md:text-2xl mb-8 max-w-3xl mx-auto px-4">
              Solutions complètes de nettoyage pour entreprises et particuliers
            </p>
            <div className="flex flex-col sm:flex-row justify-center items-center space-y-4 sm:space-y-0 sm:space-x-4 px-4">
              <Link to="/services" className="btn-primary w-full sm:w-auto">
                Nos Services
              </Link>
              <Link to="/contact" className="bg-white text-blue-600 px-6 py-3 rounded-lg font-bold hover:bg-blue-50 transition-all duration-300 w-full sm:w-auto">
                Contactez-nous
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Services Section - Amélioration du responsive */}
      <div className="py-16 sm:py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-8 sm:mb-12 font-mulish px-4">
            Nos Solutions de Nettoyage
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
            {services.map((service, index) => (
              <div 
                key={index}
                className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300"
              >
                <div className="text-4xl mb-4">{service.icon}</div>
                <h3 className="text-xl font-bold mb-2">{service.title}</h3>
                <p className="text-gray-600">{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA Section - Amélioration du responsive */}
      <div className="bg-blue-600 py-12 sm:py-16">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <h2 className="text-2xl sm:text-3xl font-bold text-white mb-4 px-4">
            Prêt à améliorer la propreté de vos espaces ?
          </h2>
          <p className="text-blue-100 mb-8 text-base sm:text-lg px-4">
            Contactez-nous dès aujourd'hui pour un devis gratuit
          </p>
          <div className="flex justify-center px-4">
            <Link 
              to="/contact" 
              className="inline-block bg-white text-blue-600 px-6 sm:px-8 py-3 sm:py-4 
                rounded-lg font-bold hover:bg-blue-50 transition-all duration-300 
                w-full sm:w-auto max-w-xs mx-auto transform hover:scale-105"
            >
              Nous Contacter
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home; 